import { Component, computed, Inject, signal } from '@angular/core';
import { ePlan } from '../../core/services/entities';
import { MasterService } from '../../core/services/master.service';
import { SignalService } from '../../core/services/signal.service';
import { Subscription } from 'rxjs';
import { HaylieService } from '../../core/services/haylie.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

type BillingCycle = 'monthly' | 'annual';

interface FaqItem {
  id: number;
  question: string;
  answer: string;
  open?: boolean;
}

@Component({
  selector: 'app-packages.component',
  imports: [FontAwesomeModule],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss',
})

export class PackagesComponent {

  faArrow = faArrowRight;
  faWhatsapp=faWhatsapp;

  public plans: ePlan[] = [];
  public faqs: FaqItem[] = [];
  // readonly billingCycle = signal<BillingCycle>('annual');
  // readonly submitState = signal<SubmitState>('idle');
  // readonly isSubmitting = signal(false);
  readonly currentYear = new Date().getFullYear();

  s_compass = Inject(SignalService).player_compass;
  s_language = Inject(SignalService).header_language;
  
  box_language = computed(() => this.s_language())
  
  subs = new Subscription;

  readonly billingCycle = signal<BillingCycle>('annual');
  
  constructor(private _svcsignal: SignalService, 
              private _svc_master: MasterService,
              private haylie: HaylieService 
              //private cdr: ChangeDetectorRef
            ) 
  {  }

  ngOnInit() {
    this.s_compass = this._svcsignal.player_compass;
    this._svcsignal.setValue("compass","home");
    this.s_language = this._svcsignal.header_language;

    this.faqs = [];
    /*
    this.subs.add(this.haylie.get_faqs().subscribe({
      next: (faqs) => {
        this.faqs = faqs.map(faq => ({
          ...faq,
          open: false 
        }));

        this.cdr.detectChanges();
      },
      error: console.error
    }));
    */

    this.plans = [];
    this.subs.add(this.haylie.get_plans().subscribe({
      next: (plans) => {
        this.plans = plans.map(p => ({
          ...p
        }));

        //this.cdr.detectChanges();
      },
      error: console.error
    }));
  }


  navigate(p_to:string): void {
    this._svc_master.navigate(p_to); 
    
  }

  readonly displayPrice = computed(() =>
    this.billingCycle() === 'annual' ? 'R$ 2.998/ano' : 'R$ 297/mes'
  );

  readonly priceNote = computed(() =>
    this.billingCycle() === 'annual'
      ? 'Economia equivalente a 2 meses em relação ao plano mensal.'
      : 'Ideal para comecar rápido e evoluir a operação sem atrito.'
  );

  setBillingCycle(cycle: string): void {
    this.billingCycle.set(cycle as BillingCycle);

    //this.cdr.detectChanges();
  }

}
